import * as React from "react";

import { graphql } from "gatsby";

import AutodesignerVideoHeroBanner from "cms/blocks/AutodesignerVideoHeroBanner";
import BigImageBlock from "cms/blocks/BigImageBlock";
import BlogArticlesBlock from "cms/blocks/BlogArticlesBlock";
import CardsBlock from "cms/blocks/CardsBlock";
import EnterpriseFormBlock from "cms/blocks/EnterpriseFormBlock";
import EnterpriseShoutoutBlock from "cms/blocks/EnterpriseShoutoutBlock";
import FaqBlock from "cms/blocks/FaqBlock";
import FeatureComparisonBlock from "cms/blocks/FeatureComparisonBlock";
import FeaturedCompaniesBlock from "cms/blocks/FeaturedCompaniesBlock";
import FloatingProfilesBannerBlock from "cms/blocks/FloatingProfilesBannerBlock";
import GoldenKittyBlock from "cms/blocks/GoldenKittyBlock";
import HeaderTextBlock from "cms/blocks/HeaderTextBlock";
import HeroWithImageBlock from "cms/blocks/HeroWithImageBlock";
import HomepageBannerBlock from "cms/blocks/HomepageBannerBlock";
import LigmaHeroBannerBlock from "cms/blocks/LigmaHeroBannerBlock";
import MicrosoftStartupHeroBannerBlock from "cms/blocks/MicrosoftStartupHeroBannerBlock";
import MicrosoftStartupTwoCardBlock from "cms/blocks/MicrosoftStartupTwoCardBlock";
import MicrosoftStatementBlock from "cms/blocks/MicrosoftStatementBlock";
import MordorBentoCardsBlock from "cms/blocks/MordorBentoCardsBlock";
import MordorBlogArticlesBlock from "cms/blocks/MordorBlogArticlesBlock";
import MordorCaseStudyBlock from "cms/blocks/MordorCaseStudyBlock";
import MordorFaqBlock from "cms/blocks/MordorFaqBlock";
import MordorHomepageBannerBlock from "cms/blocks/MordorHomepageBannerBlock";
import MordorSocialProofBlock from "cms/blocks/MordorSocialProofBlock";
import MordorValuePropositionBlock from "cms/blocks/MordorValuePropositionBlock";
import OneCardBlock from "cms/blocks/OneCardBlock";
import PitchBlock from "cms/blocks/PitchBlock";
import PreviewTemplateBlock from "cms/blocks/PreviewTemplateBlock";
import PromoCodeBlock from "cms/blocks/PromoCodeBlock";
import SectionConversionBlock from "cms/blocks/SectionConversionBlock";
import SectionWithImageBlock from "cms/blocks/SectionWithImageBlock";
import ShoutoutBlock from "cms/blocks/ShoutoutBlock";
import SocialProofBlock from "cms/blocks/SocialProofBlock";
import TemplateCategoryBlock from "cms/blocks/TemplateCategoryBlock";
import TemplateSuggestionsBlock from "cms/blocks/TemplateSuggestionsBlock";
import TwoCardBlock from "cms/blocks/TwoCardBlock";
import UizardVsDesignFuglyBlock from "cms/blocks/UizardVsDesignFuglyBlock";
import YoutubeBlock from "cms/blocks/YoutubeBlock";

export interface BlocksProps {
  blocks: Queries.Maybe<Queries.SanityBlockPage["blocks"]>;
  pageContext?: {
    imageCache: Record<string, any>;
  };
}

const Blocks: React.FC<BlocksProps> = ({ blocks, pageContext }) => {
  return (
    <React.Fragment>
      {blocks?.map((block) => {
        if (block?._type === "templateCategoryBlock") {
          return (
            <TemplateCategoryBlock
              key={block._key}
              {...(block as Queries.SanityTemplateCategoryBlock)}
              pageContext={pageContext}
            />
          );
        }

        if (block?._type === "faqBlock") {
          return (
            <FaqBlock key={block._key} {...(block as Queries.SanityFaqBlock)} />
          );
        }

        if (block?._type === "shoutoutBlock") {
          return (
            <ShoutoutBlock
              key={block._key}
              {...(block as Queries.SanityShoutoutBlock)}
            />
          );
        }

        if (block?._type === "enterpriseShoutoutBlock") {
          return (
            <EnterpriseShoutoutBlock
              key={block._key}
              {...(block as Queries.SanityEnterpriseShoutoutBlock)}
            />
          );
        }

        if (block?._type === "floatingProfilesBannerBlock") {
          return (
            <FloatingProfilesBannerBlock
              key={block._key}
              {...(block as Queries.SanityFloatingProfilesBannerBlock)}
            />
          );
        }

        if (block?._type === "enterpriseFormBlock") {
          return (
            <EnterpriseFormBlock
              key={block._key}
              {...(block as Queries.SanityEnterpriseFormBlock)}
            />
          );
        }

        if (block?._type === "sectionWithImageBlock") {
          return (
            <SectionWithImageBlock
              key={block._key}
              {...(block as Queries.SanitySectionWithImageBlock)}
            />
          );
        }

        if (block?._type === "blogArticlesBlock") {
          return (
            <BlogArticlesBlock
              key={block._key}
              {...(block as Queries.SanityBlogArticlesBlock)}
            />
          );
        }

        if (block?._type === "oneCardBlock") {
          return (
            <OneCardBlock
              key={block._key}
              {...(block as Queries.SanityOneCardBlock)}
            />
          );
        }

        if (block?._type === "twoCardBlock") {
          return (
            <TwoCardBlock
              key={block._key}
              {...(block as Queries.SanityTwoCardBlock)}
            />
          );
        }

        if (block?._type === "cardsBlock") {
          return (
            <CardsBlock
              key={block._key}
              {...(block as Queries.SanityCardsBlock)}
            />
          );
        }

        if (block?._type === "heroWithImageBlock") {
          return (
            <HeroWithImageBlock
              key={block._key}
              {...(block as Queries.SanityHeroWithImageBlock)}
            />
          );
        }

        if (block?._type === "featuredCompaniesBlock") {
          return (
            <FeaturedCompaniesBlock
              key={block._key}
              {...(block as Queries.SanityFeaturedCompaniesBlock)}
            />
          );
        }

        if (block?._type === "templateSuggestionsBlock") {
          return (
            <TemplateSuggestionsBlock
              key={block._key}
              {...(block as Queries.SanityTemplateSuggestionsBlock)}
            />
          );
        }

        if (block?._type === "sectionConversionBlock") {
          return (
            <SectionConversionBlock
              key={block._key}
              {...(block as Queries.SanitySectionConversionBlock)}
            />
          );
        }

        if (block?._type === "headerTextBlock") {
          return (
            <HeaderTextBlock
              key={block._key}
              {...(block as Queries.SanityHeaderTextBlock)}
            />
          );
        }

        if (block?._type === "homepageBannerBlock") {
          return (
            <HomepageBannerBlock
              key={block._key}
              {...(block as Queries.SanityHomepageBannerBlock)}
            />
          );
        }

        if (block?._type === "microsoftStartupHeroBannerBlock") {
          return (
            <MicrosoftStartupHeroBannerBlock
              key={block._key}
              {...(block as Queries.SanityMicrosoftStartupHeroBannerBlock)}
            />
          );
        }

        if (block?._type === "microsoftStartupTwoCardBlock") {
          return (
            <MicrosoftStartupTwoCardBlock
              key={block._key}
              {...(block as Queries.SanityMicrosoftStartupTwoCardBlock)}
            />
          );
        }

        if (block?._type === "microsoftStatementBlock") {
          return (
            <MicrosoftStatementBlock
              key={block._key}
              {...(block as Queries.SanityMicrosoftStatementBlock)}
            />
          );
        }

        if (block?._type === "pitchBlock") {
          return (
            <PitchBlock
              key={block._key}
              {...(block as Queries.SanityPitchBlock)}
            />
          );
        }

        if (block?._type === "goldenKittyBlock") {
          return (
            <GoldenKittyBlock
              key={block._key}
              {...(block as Queries.SanityGoldenKittyBlock)}
            />
          );
        }

        if (block?._type === "youtubeBlock") {
          return (
            <YoutubeBlock
              key={block._key}
              {...(block as Queries.SanityYoutubeBlock)}
            />
          );
        }

        if (block?._type === "autodesignerVideoHeroBanner") {
          return (
            <AutodesignerVideoHeroBanner
              key={block._key}
              {...(block as Queries.SanityAutodesignerVideoHeroBanner)}
            />
          );
        }

        if (block?._type === "bigImageBlock") {
          return (
            <BigImageBlock
              key={block._key}
              {...(block as Queries.SanityBigImageBlock)}
            />
          );
        }

        if (block?._type === "ligmaHeroBannerBlock") {
          return (
            <LigmaHeroBannerBlock
              key={block._key}
              {...(block as Queries.SanityLigmaHeroBannerBlock)}
            />
          );
        }

        if (block?._type === "uizardVsDesignFuglyBlock") {
          return (
            <UizardVsDesignFuglyBlock
              key={block._key}
              {...(block as Queries.SanityUizardVsDesignFuglyBlock)}
            />
          );
        }

        if (block?._type === "socialProofBlock") {
          return (
            <SocialProofBlock
              key={block._key}
              {...(block as Queries.SanitySocialProofBlock)}
            />
          );
        }

        if (block?._type === "promoCodeBlock") {
          return (
            <PromoCodeBlock
              key={block._key}
              {...(block as Queries.SanityPromoCodeBlock)}
            />
          );
        }

        if (block?._type === "previewTemplateBlock") {
          return (
            <PreviewTemplateBlock
              key={block._key}
              {...(block as Queries.SanityPreviewTemplateBlock)}
            />
          );
        }

        if (block?._type === "featureComparisonBlock") {
          return (
            <FeatureComparisonBlock
              key={block._key}
              {...(block as Queries.SanityFeatureComparisonBlock)}
            />
          );
        }

        if (block?._type === "mordorHomepageBannerBlock") {
          return (
            <MordorHomepageBannerBlock
              key={block._key}
              {...(block as Queries.SanityMordorHomepageBannerBlock)}
            />
          );
        }

        if (block?._type === "mordorSocialProofBlock") {
          return (
            <MordorSocialProofBlock
              key={block._key}
              {...(block as Queries.SanityMordorSocialProofBlock)}
            />
          );
        }

        if (block?._type === "mordorCaseStudyBlock") {
          return (
            <MordorCaseStudyBlock
              key={block._key}
              {...(block as Queries.SanityMordorCaseStudyBlock)}
            />
          );
        }

        if (block?._type === "mordorValuePropositionBlock") {
          return (
            <MordorValuePropositionBlock
              key={block._key}
              {...(block as Queries.SanityMordorValuePropositionBlock)}
            />
          );
        }

        if (block?._type === "mordorBentoCardsBlock") {
          return (
            <MordorBentoCardsBlock
              key={block._key}
              {...(block as Queries.SanityMordorBentoCardsBlock)}
            />
          );
        }

        if (block?._type === "mordorFaqBlock") {
          return (
            <MordorFaqBlock
              key={block._key}
              {...(block as Queries.SanityMordorFaqBlock)}
            />
          );
        }

        if (block?._type === "mordorBlogArticlesBlock") {
          return (
            <MordorBlogArticlesBlock
              key={block._key}
              {...(block as Queries.SanityMordorBlogArticlesBlock)}
            />
          );
        }

        return null;
      })}
    </React.Fragment>
  );
};

export const query = graphql`
  fragment BlockPageBlocks on SanityBlockPage {
    blocks {
      ...TemplateCategoryBlock
      ...FaqBlock
      ...ShoutoutBlock
      ...EnterpriseShoutoutBlock
      ...FloatingProfilesBannerBlock
      ...EnterpriseFormBlock
      ...SectionWithImageBlock
      ...BlogArticlesBlock
      ...OneCardBlock
      ...TwoCardBlock
      ...CardsBlock
      ...HeroWithImageBlock
      ...FeaturedCompaniesBlock
      ...TemplateSuggestionsBlock
      ...SectionConversionBlock
      ...HeaderTextBlock
      ...HomepageBannerBlock
      ...MicrosoftStartupHeroBannerBlock
      ...MicrosoftStartupTwoCardBlock
      ...MicrosoftStatementBlock
      ...PitchBlock
      ...GoldenKittyBlock
      ...YoutubeBlock
      ...AutodesignerVideoHeroBanner
      ...BigImageBlock
      ...LigmaHeroBannerBlock
      ...UizardVsDesignFuglyBlock
      ...SocialProofBlock
      ...PromoCodeBlock
      ...PreviewTemplateBlock
      ...FeatureComparisonBlock
      ...MordorHomepageBannerBlock
      ...MordorSocialProofBlock
      ...MordorCaseStudyBlock
      ...MordorValuePropositionBlock
      ...MordorBentoCardsBlock
      ...MordorFaqBlock
      ...MordorBlogArticlesBlock
    }
  }

  fragment TemplateOverviewPageBlocks on SanityTemplateOverviewPage {
    blocks {
      ...TemplateCategoryBlock
      ...FaqBlock
      ...ShoutoutBlock
      ...EnterpriseShoutoutBlock
      ...FloatingProfilesBannerBlock
      ...EnterpriseFormBlock
      ...SectionWithImageBlock
      ...BlogArticlesBlock
      ...OneCardBlock
      ...TwoCardBlock
      ...CardsBlock
      ...HeroWithImageBlock
      ...FeaturedCompaniesBlock
      ...TemplateSuggestionsBlock
      ...SectionConversionBlock
      ...HeaderTextBlock
      ...HomepageBannerBlock
      ...MicrosoftStartupHeroBannerBlock
      ...MicrosoftStartupTwoCardBlock
      ...MicrosoftStatementBlock
      ...PitchBlock
      ...GoldenKittyBlock
      ...YoutubeBlock
      ...AutodesignerVideoHeroBanner
      ...BigImageBlock
      ...LigmaHeroBannerBlock
      ...UizardVsDesignFuglyBlock
      ...SocialProofBlock
      ...PromoCodeBlock
      ...PreviewTemplateBlock
      ...FeatureComparisonBlock
      ...MordorHomepageBannerBlock
      ...MordorSocialProofBlock
      ...MordorCaseStudyBlock
      ...MordorValuePropositionBlock
      ...MordorBentoCardsBlock
      ...MordorFaqBlock
      ...MordorBlogArticlesBlock
    }
  }

  fragment TemplateCategoryPageBlocks on SanityTemplateCategoryPage {
    blocks {
      ...TemplateCategoryBlock
      ...FaqBlock
      ...ShoutoutBlock
      ...EnterpriseShoutoutBlock
      ...FloatingProfilesBannerBlock
      ...EnterpriseFormBlock
      ...SectionWithImageBlock
      ...BlogArticlesBlock
      ...OneCardBlock
      ...TwoCardBlock
      ...CardsBlock
      ...HeroWithImageBlock
      ...FeaturedCompaniesBlock
      ...TemplateSuggestionsBlock
      ...SectionConversionBlock
      ...HeaderTextBlock
      ...HomepageBannerBlock
      ...MicrosoftStartupHeroBannerBlock
      ...MicrosoftStartupTwoCardBlock
      ...MicrosoftStatementBlock
      ...PitchBlock
      ...GoldenKittyBlock
      ...YoutubeBlock
      ...AutodesignerVideoHeroBanner
      ...BigImageBlock
      ...LigmaHeroBannerBlock
      ...UizardVsDesignFuglyBlock
      ...SocialProofBlock
      ...PromoCodeBlock
      ...PreviewTemplateBlock
      ...FeatureComparisonBlock
      ...MordorHomepageBannerBlock
      ...MordorSocialProofBlock
      ...MordorCaseStudyBlock
      ...MordorValuePropositionBlock
      ...MordorBentoCardsBlock
      ...MordorFaqBlock
      ...MordorBlogArticlesBlock
    }
  }

  fragment PricingPageBlocks on SanityPricingPage {
    blocks {
      ...TemplateCategoryBlock
      ...FaqBlock
      ...ShoutoutBlock
      ...EnterpriseShoutoutBlock
      ...FloatingProfilesBannerBlock
      ...EnterpriseFormBlock
      ...SectionWithImageBlock
      ...BlogArticlesBlock
      ...OneCardBlock
      ...TwoCardBlock
      ...CardsBlock
      ...HeroWithImageBlock
      ...FeaturedCompaniesBlock
      ...TemplateSuggestionsBlock
      ...SectionConversionBlock
      ...HeaderTextBlock
      ...HomepageBannerBlock
      ...MicrosoftStartupHeroBannerBlock
      ...MicrosoftStartupTwoCardBlock
      ...MicrosoftStatementBlock
      ...PitchBlock
      ...GoldenKittyBlock
      ...YoutubeBlock
      ...AutodesignerVideoHeroBanner
      ...BigImageBlock
      ...LigmaHeroBannerBlock
      ...UizardVsDesignFuglyBlock
      ...SocialProofBlock
      ...PromoCodeBlock
      ...PreviewTemplateBlock
      ...FeatureComparisonBlock
      ...MordorHomepageBannerBlock
      ...MordorSocialProofBlock
      ...MordorCaseStudyBlock
      ...MordorValuePropositionBlock
      ...MordorBentoCardsBlock
      ...MordorFaqBlock
      ...MordorBlogArticlesBlock
    }
  }
`;

export default Blocks;
